export const uploadToCloudinary = async (file, folder) => {
  const form = new FormData();
  form.append('file', file);
  form.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
  form.append('folder', folder);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/raw/upload`,
    { method: 'POST', body: form }
  );

  if (!res.ok) {
    throw new Error('File upload failed. Please check your file and try again.');
  }

  return res.json();
};
